import type { FC } from 'react';

import { useBreakpoint, VSpacing } from '@hh.ru/magritte-ui';

import { BalanceAndBonusesCards } from 'components/BalanceAndBonuses/BalanceAndBonusesCards/BalanceAndBonusesCards';
import { History } from 'components/BalanceAndBonuses/History/History';
import { PromoCodeCard } from 'components/BalanceAndBonuses/PromoCodeCard/PromoCodeCard';

import styles from 'components/BalanceAndBonuses/BalanceAndBonuses.module.less';

export const BalanceAndBonuses: FC = () => {
    const { isMobile } = useBreakpoint();

    return (
        <>
            <BalanceAndBonusesCards />
            <VSpacing default={isMobile ? 32 : 40} />
            <div className={styles.bottomWrapper}>
                <History />
                <PromoCodeCard />
            </div>
            <VSpacing default={32} />
        </>
    );
};
